import React from 'react';
import Helmet from 'react-helmet';

interface Props {
  isRoot: boolean;
}

const Ogp: React.FC<Props> = ({ isRoot }) => {
  const type = isRoot ? 'website' : 'article';

  const title = 'ぴんとくるくる浄土';
  const blogTitle = 'ぴんとくるくる浄土';
  const blogImageUrl =
    'https://static.juggling-mstdn.net/media_attachments/files/000/000/020/original/d6d70c0286442d4e.jpg';
  const description =
    'Juggling Unit ピントクルによる「これからのジャグリング」を模索する発表会';
  const blogUrl = 'https://pintcle-jodo.netlify.com';

  return (
    <Helmet>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      <meta property="og:url" content={blogUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={blogTitle} />
      <meta property="og:image" content={blogImageUrl} />
      {/* <meta property="fb:app_id" content={facebookAppId} /> */}
      <meta name="twitter:image" content={blogImageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@JugglingPintcle" />
      <title>{title}</title>
    </Helmet>
  );
};

export default Ogp;
